import React from "react";
import "./Loader.css";

function Loader() {
  return <div className="loader" />;
}

export default Loader;
